<a class="sidemenu-trigger" [ngClass]="linkClass" (click)="sidebarVisible = true">
  <fa-icon [icon]="faMenu" />
</a>

<p-sidebar #sidemenu [(visible)]="sidebarVisible" position="right" [appendTo]="appendTo" [modal]="true">
  <ng-content />
</p-sidebar>
<div
  #overlay
  class="overlay"
  [ngStyle]="{
    display: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 'var(--z-index-overlay,' + overlayZIndex + ')',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  }"
>
  <a
    (click)="sidebarVisible = false"
    [ngStyle]="{
      display: 'block',
      width: '100%',
      height: '100%',
      cursor: 'pointer'
    }"
  ></a>
</div>
